import { buildElementId } from '../utils';

import {
  ValidateNumeric,
  ValidateSelector,
  ValidatePropertyCode,
  ValidateRegExp,
} from './ElementValidators';

const getValue = (answer) => {
  return (answer || { value: '' }).value;
};

const validateForest = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {

  // Property code
    newErrors = ValidatePropertyCode(
      getValue(questions.propertyCode),
      buildElementId(id, 'FOREST_PROPERTYCODE'),
      newErrors,
      validateAll,
      1,
      questionID,
      '^(\\d{3}-?\\d{3}-?\\d{4}-?\\d{4}((M|-M|m|-m)?\\d{4})?)$',
      getMessage
        ? `${caption} : ${
            questions.propertyCode?.question ||
            getMessage('labelText.forestPropertCode')
          } - ${getMessage('error.fill.in.missing.information')}`
        : ''
    );

  // Other Vehicle Registration number
    newErrors = ValidateRegExp({
      value: getValue(questions.nameOfTheForestEstateAndLocality),
      id: buildElementId(id, 'FOREST_NAME_OF_THE_FOREST_ESTATE_AND_LOCALITY'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp:
        '(^[0-9a-zA-Z\u00C0-\u017F´` ]+$|^$)',
      maxLimit: 100,
      errorLabel: getMessage
      ? `${caption} : ${
          questions.nameOfTheForestEstateAndLocality?.question ||
          getMessage('labelText.forestNameOfTheForestEstateAndLocality')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
    });

  // Area
  newErrors = ValidateNumeric(
    getValue(questions.area),
    buildElementId(id, 'FOREST_AREA'),
    newErrors,
    validateAll,
    1,
    99999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.area?.question || getMessage('labelText.forestArea')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // Indemnity
  newErrors = ValidateSelector(
    getValue(questions.indemnity),
    buildElementId(id, 'FOREST_INDEMNITY'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.indemnity?.question ||
          getMessage('labelText.forestIndemnity')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // Growth stage
  newErrors = ValidateSelector(
    getValue(questions.growthstage),
    buildElementId(id, 'FOREST_GROWTHSTAGE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.growthstage?.question ||
          getMessage('labelText.forestGrowthStage')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  return {
    add: newErrors.add.filter(Boolean),
    remove: newErrors.remove.filter(Boolean),
  };
};

const validateForestQuestions = (
  id,
  questions,
  validateAll,
  questionID,
  errors,
  caption,
  getMessage
) => {
let newErrors = { add: [], remove: [] };
  const forestType = questions.forestType || { value: '' };
  // Mandatory, validate always type
  newErrors = ValidateSelector(
    forestType.value,
    buildElementId(id, 'FOREST_MUNICIPALITY'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
        forestType.question || getMessage('labelText.forestMunicipality')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '' 
  );

  if (validateAll === true && forestType.value === 'choose') {
    newErrors.remove = [
      ...newErrors.remove,
      ...errors
        .filter(
          (record) =>
            record.id.indexOf(id) !== -1 && record.id !== id + '_FOREST_MUNICIPALITY'
        )
        .map((record) => record.id),
    ];
  }
  return validateForest(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );
};

export default validateForestQuestions;